import { message, Spin } from "antd";
import { isAxiosError } from "axios";
import { useState } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "@hooks";

import { LoginEmail } from "@components/molecules";
import { ArrowLeft, EnvelopeSimple } from "@phosphor-icons/react";
import './Login.css';

export const Login = () => {
  const [emailSent, setEmailSent] = useState(false);
  const [userEmail, setUserEmail] = useState("");

  const { sendAccessLink, profile } = useAuth();

  const { data: profileData, isLoading: isLoadingData } = profile;

  const handleSendAccessLink = (data: { email: string }) => {
    setUserEmail(data.email);

    sendAccessLink.mutate(data.email, {
      onSuccess: () => {
        setEmailSent(true);
        message.success(`Access link sent to ${data.email}`);
      },
      onError: (error) => {
        const defaultMessage = "Error sending access link";
        if (isAxiosError(error)) {
          message.error(error.response?.data.message || defaultMessage);
        } else {
          message.error(defaultMessage);
        }
      },
    });
  };

  // If user is already logged in, redirect to home page
  if (!isLoadingData && profileData?.email) {
    return <Navigate to="/" />;
  }

  return (
    <Spin spinning={sendAccessLink.isPending}>
      <div className="flex min-h-screen bg-[url(/assets/images/bg-ruppert-ready-to-start.png)] bg-cover justify-center items-center relative">
        <div className="absolute top-5 left-5 z-50">
          <a
            href="/"
            className="back-to-website-link flex items-center gap-2 font-medium font-barlow no-underline"
          >
            <ArrowLeft size={16} />
            Back to website
          </a>
        </div>
        <div className="flex flex-col justify-center items-center p-8 w-full max-w-md">
          <h2 className="mb-10 flex justify-center">
            <img src="/assets/logos/ruppert-logo.svg" alt="Ruppert" className="w-40 md:w-20" />
          </h2>

          {!emailSent ? (
            <LoginEmail onFinish={handleSendAccessLink} />
          ) : (
            <div className="bg-white p-8 rounded-none shadow-sm text-center" style={{ borderRadius: 0 }}>
              <div className="flex justify-center mb-4">
                <EnvelopeSimple size={48} weight="regular" className="text-yellow-principal" />
              </div>
              <h2 className="text-xl font-semibold mb-2 font-android uppercase">Check your email</h2>
              <p className="font-barlow font-normal text-black text-base md:text-md mb-6">
                We've sent an access link to <span className="font-medium">{userEmail}</span>
                <br />
                Click the link in the email to sign in.
              </p>
              <button
                onClick={() => setEmailSent(false)}
                className="try-another-email-btn text-base md:text-xl uppercase font-normal mt-4"
              >
                Try another email
              </button>
            </div>
          )}
        </div>
      </div>
    </Spin>
  );
};
